module.exports = __webpack_public_path__ + "static/architecture-e8de168e5bcb04965e8f60acd3885849.png";